var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.502 3.38788C15.5276 3.70587 15.4882 4.02584 15.3865 4.32822C15.2848 4.6306 15.1228 4.9092 14.9103 5.14712C14.6977 5.38503 14.4389 5.57739 14.1499 5.71237C13.8607 5.84742 13.5474 5.9223 13.2285 5.93257C12.9095 5.94292 12.5919 5.88832 12.2947 5.77225C11.9975 5.65615 11.727 5.48094 11.4995 5.25721C11.2721 5.03348 11.0924 4.7659 10.9714 4.4707C10.8504 4.17547 10.7906 3.85877 10.7956 3.53975L9.1981 3.51189C8.77982 3.52292 8.38276 3.69846 8.0931 4.00042C7.80344 4.30238 7.64454 4.70638 7.65089 5.12477L7.95064 20.4684L7.96375 22.4193C7.9748 22.8376 8.15032 23.2346 8.45222 23.5242C8.75421 23.8139 9.1582 23.9728 9.57662 23.9665L17.456 23.8214C17.8743 23.8104 18.2713 23.6348 18.561 23.3328C18.8507 23.0309 19.0096 22.6268 19.0032 22.2086L18.6685 4.86517C18.6532 4.4652 18.4877 4.08569 18.2047 3.80258C17.9219 3.51938 17.5426 3.35335 17.1427 3.33764L15.502 3.38788Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66901 10.8374L16.6688 10.7873",
    stroke: "#828282",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68331 12.8373L16.6831 12.7873",
    stroke: "#828282",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69762 14.8373L16.6974 14.7872",
    stroke: "#828282",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71192 16.8372L16.7117 16.7872",
    stroke: "#828282",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintTickets);
export default __webpack_public_path__ + "static/media/printTickets.3ce34ffae24150e236bbdefd4cb9f056.svg";
export { ForwardRef as ReactComponent };